export function getDate(dateTime: string, locale: string, format?: 'long' | 'short') {
	const date = new Date(dateTime)
	return date.toLocaleDateString(locale, {
		year: 'numeric',
		month: format || 'short',
		day: 'numeric'
	})
}
